export default __webpack_public_path__ + "static/media/avatar_2.772d8244.svg";